module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-3-98818b26a803d443b03d06852946b579.png";